// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mvuxo{display:flex;gap:24px;align-items:stretch;width:100%;height:100%}.lYper{display:flex;flex-direction:column;gap:20px;flex:1;min-height:0}.STMRZ{flex:none;width:100%;aspect-ratio:1/1}.STMRZ.n2t4D{aspect-ratio:auto;height:140px}.NYCS_{flex:3;min-width:0;display:flex;align-items:stretch;height:100%;container-type:inline-size}.BsKQe{width:100%;height:100%}@container (min-width: 720px){.BsKQe{zoom:1.3}}@container (min-width: 960px){.BsKQe{zoom:1.6}}@container (min-width: 1200px){.BsKQe{zoom:2}}.cVeHx{width:100%}.ZXXyj{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Mvuxo`,
	"leftColumn": `lYper`,
	"logoPickerWrapper": `STMRZ`,
	"logoPickerMobile": `n2t4D`,
	"previewWrapper": `NYCS_`,
	"preview": `BsKQe`,
	"mobileRoot": `cVeHx`,
	"mobilePreview": `ZXXyj`
};
export default ___CSS_LOADER_EXPORT___;
